import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MenuModuleCourseComponent } from "../../components/menu-module-course/menu-module-course.component";

@Component({
    selector: 'app-course',
    standalone: true,
    templateUrl: './course.component.html',
    styleUrls: ['./course.component.scss'],
    imports: [CommonModule, RouterOutlet, MenuModuleCourseComponent]
})
export class CourseComponent {

}
